export enum DocumentEditorInstantaneousContentActionType {
  Duplicate = 'duplicate',
  Move = 'move',
  SetFoldingMode = 'setFoldingMode',
  Delete = 'delete',
  Reinitialize = 'reinitialize',
  SetCustomPageBreakBefore = 'setCustomPageBreakBefore',
  SetPageBreakBefore = 'setPageBreakBefore',
  SetCustomPageBreakAfter = 'setCustomPageBreakAfter',
  SetPageBreakAfter = 'setPageBreakAfter',
  SetOrientation = 'setOrientation',
  SetPaperFormat = 'setPaperFormat',
  SetDisplayCondition = 'setDisplayCondition',
}
